import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import LinkCurationContentParser from './LinkCurationContentParser';
import {
  LinkCurationContainer,
  LinkContentWrapper,
  LinkImage,
  ImageWrapper,
  ImageContainer,
  CustomDescription,
  Title,
  TextWrapper,
  Text,
  StaticLink,
  LinkIcon,
  StaticLinkWrapper
} from './LinkCuration.styled';

export const LinkCuration = ({ content }) => {
  const [data] = useState(LinkCurationContentParser(content));
  const { title, text, imgUrl, imgClasses, resourceUrl, customDescription } = data;
  return (
    <LinkCurationContainer>
      {customDescription && <CustomDescription>{customDescription}</CustomDescription>}
      <LinkContentWrapper href={resourceUrl} target="_blank">
        <ImageContainer>
          <ImageWrapper className={imgClasses}>
            <LinkImage src={imgUrl} alt={title} title={title} />
          </ImageWrapper>
        </ImageContainer>
        <TextWrapper>
          <Title title={title}>{title}</Title>
          <Text title={text}>{text}</Text>
          <StaticLinkWrapper title={resourceUrl}>
            <LinkIcon size={12} name="link" />
            <StaticLink>{resourceUrl}</StaticLink>
          </StaticLinkWrapper>
        </TextWrapper>
      </LinkContentWrapper>
    </LinkCurationContainer>
  );
};

LinkCuration.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.object
};

export default withTheme(LinkCuration);
